//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PID.js";
import "../no/Builder.js";
import "../no/Assemblies.js";
import "../no/PDM.js";
import "../no/Diagramming.js";
let d=[[[0,"ManualUpdate",1,0],[0,"ObjectType",1,0],[0,"OutputControlLoop",1,0],[0,"OutputEquipment",1,0],[0,"OutputInlineEquipmentValve",1,0],[0,"OutputInstrumentation",1,0],[0,"OutputRun",1,0],[0,"ScopeType",1,0],[0,"Sheet",1,"PID.Sheet",0],[0,"StockType",1,0],[0,"System",1,"Assemblies.Partition",0],[0,"Table",1,"Diagramming.Tables.TableBuilder",0]],[[[],"GetNumberOfPropertyCellRanges",{R_:{number:''}},0,0],[["index"],"GetPropertyCellRange",{R_:{propertyCellRange:"PID.PropertyCellRangeBuilder"}},1,0],[["index","propertyTypes","propertyKeys"],"InsertPropertyCellRanges",{},3,0],[["index","number"],"RemovePropertyCellRanges",{},2,0]],[]];
SPLM.PID.AutomaticTableBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PID.AutomaticTableBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PID.AutomaticTableBuilder.ScopeTypeOption = Object.freeze({
    "CurrentSheet" : "CurrentSheet", "OtherSheet" : "OtherSheet", "System" : "System"});

SPLM.PID.AutomaticTableBuilder.ObjectTypeOption = Object.freeze({
    "Equipment" : "Equipment", "InlineEquipment" : "InlineEquipment", "Run" : "Run", "PipeStock" : "PipeStock"});

SPLM.PID.AutomaticTableBuilder.StockOption = Object.freeze({
    "Pipe" : "Pipe", "Instrumentation" : "Instrumentation", "Hvac" : "Hvac"});

export default SPLM;